import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ease } from '../../core/format/motion';
type Props = {
  children: ReactNode;
  className?: string;
  /** Kleine vertraging binnen een rij (stagger), in seconden. Houd het totaal onder ±0,25 s. */
  delay?: number;
  as?: 'div' | 'li' | 'figure';
};

/**
 * Eén keer zacht in beeld komen bij het scrollen (opacity + 12px), daarna staat alles stil.
 * Alleen voor beeld en grote koppen, niet voor elke regel tekst (docs/VORMGEVING.md §1).
 * Met "minder beweging": direct zichtbaar.
 */
export function Reveal({
  children,
  className,
  delay = 0,
  as = 'div'
}: Props) {
  const reduce = useReducedMotion();
  const Tag = motion[as];
  return <Tag initial={reduce ? false : {
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease
  }} className={className} data-id="element-8731" data-mp="2v74f49t3zk8p">
      {children}
    </Tag>;
}